export const currencyFormatter = new Intl.NumberFormat('en-US', {
  currency: 'USD',
  style: 'currency',
  minimumFractionDigits: 2,
  useGrouping: true,
})

/**
 * Formats a number as a currency string without the currency symbol. Used for
 * form input fields.
 */
export function formatFormInputCurrencyString(v: string): string | undefined {
  const n = Number.parseFloat(v.replace(/[^0-9.]/g, ''))
  if (!Number.isNaN(n)) {
    let parts = currencyFormatter.formatToParts(n)
    if (parts.length === 0) return
    if (parts.find((p) => p.type === 'fraction')?.value === '00') {
      parts = parts.filter((p) => !['fraction', 'decimal'].includes(p.type))
    }
    return parts
      .filter((p) => p.type !== 'currency')
      .map((p) => p.value)
      .join('')
  }
}

export function formatFormInputCurrencyStringLenient(val: string): string {
  const v = val
    .replace(/[^0-9.]/g, '')
    .replace(/\.+/g, '.')
    .trim()
  if (v.length === 0) return ''
  const n = Number.parseFloat(v)
  if (Number.isNaN(n)) return ''
  let parts = currencyFormatter.formatToParts(n).filter((p) => p.type !== 'currency')
  if (parts.length === 0) return ''
  const arr = v.split('.')
  const decimal = arr.length > 1 ? arr[1] : undefined
  if (decimal && decimal.length === 1) {
    const d = parts.find((p) => p.type === 'fraction')
    if (d) {
      d.value = decimal
    }
    return parts.map((p) => p.value).join('')
  }
  if (v.endsWith('.')) {
    const pre = parts
      .filter((p) => !['fraction', 'decimal'].includes(p.type))
      .map((p) => p.value)
      .join('')
    return `${pre}.`
  }
  if (parts.find((p) => p.type === 'fraction')?.value === '00') {
    parts = parts.filter((p) => !['fraction', 'decimal'].includes(p.type))
  }
  return parts.map((p) => p.value).join('')
}
